import React, { forwardRef } from 'react';
import { useSurveyFormatContext } from './useSurveyFormatContext';
import { OQAATView, ClassicView } from './views';
import { SurveyFormat } from './constants';
import { SurveyFormatViewFactoryProps } from './types';

export function SurveyFormatViewFactory(
  { name, ...props }: SurveyFormatViewFactoryProps,
  forwardedRef?: React.Ref<HTMLDivElement>
): React.ReactElement {
  const { format } = useSurveyFormatContext();

  const View = React.useMemo(() => {
    switch (format) {
      case SurveyFormat.ONE_QUESTION_AT_A_TIME: {
        return OQAATView;
      }
      case SurveyFormat.CLASSIC:
      default: {
        return ClassicView;
      }
    }
  }, [format]);

  return <View name={name} ref={forwardedRef} {...props} />;
}

export default forwardRef<HTMLDivElement, SurveyFormatViewFactoryProps>(SurveyFormatViewFactory);
